import { Group, GroupTitle, getToken } from "ra-friendsofbabba";

import { API_URL } from "../../config";
import CannotViewField from "./CannotViewField";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import PrintIcon from "@material-ui/icons/Print";
import React from "react";
import { get } from "lodash";
import usePrivileges from "../usePrivileges";
import { useTranslate } from "ra-core";

const options = [
  "resources.technical-report-evals.buttons.print_proposal",
  "resources.technical-report-evals.buttons.print_executive_project",
  "resources.technical-report-evals.buttons.print_technical_report",
  //   "resources.technical-report-evals.buttons.print_technical_report_eval",
];
const PrintableDocsField = ({ record, reportType, ...props }) => {
  const handleMenuItemClick = (option) => {
    let printArgs = option.split(".");
    let print = printArgs[printArgs.length - 1];
    let action;
    switch (print) {
      case "print_proposal":
        action = `/technical-report-evals/print-proposal?id=${get(
          record,
          "id"
        )}`;
        break;
      case "print_executive_project":
        action = `/executive-projects/print?id=${get(
          record,
          "technical_report.executive_project_id"
        )}`;
        break;
      case "print_technical_report":
        action = `/technical-reports/print?id=${get(
          record,
          "technical_report_id"
        )}`;
        break;
      case "print_technical_report_eval":
        action = `/technical-report-evals/print?id=${get(record, "id")}`;
        break;
      default:
        break;
    }
    action = `${API_URL}${action}&token=${getToken()}`;
    window.open(action, "_blank");
  };
  const translate = useTranslate();
  const { canView } = usePrivileges({ record });
  if (!canView) {
    return (
      <CannotViewField record={record} source="printable_docs" {...props} />
    );
  }
  return (
    <Group wrapper>
      <GroupTitle
        subTitle={translate(
          "resources.technical-report-evals.printable_docs.help"
        )}
      />
      <List component="nav" aria-label="printable-docs">
        {options.map((option, index) => (
          <ListItem button key={index}>
            <ListItemIcon>
              <PrintIcon />
            </ListItemIcon>
            <ListItemText
              onClick={handleMenuItemClick.bind(this, option)}
              primary={translate(
                option +
                  (option ===
                    "resources.technical-report-evals.buttons.print_technical_report" &&
                  reportType === 3
                    ? "_final"
                    : "")
              )}
              secondary={
                translate(`${option}.help`) !== `${option}.help`
                  ? translate(`${option}.help`)
                  : null
              }
            />
          </ListItem>
        ))}
      </List>
    </Group>
  );
};

export default PrintableDocsField;
